import React from 'react';
import { motion } from 'framer-motion';
export function CallToAction() {
  return <section className="py-24 px-6" data-id="element-25" data-mp="1i2k0fl5zpslp">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto bg-gradient-to-br from-peach to-coral rounded-[3rem] p-12 md:p-20 text-center relative overflow-hidden shadow-soft-lg" data-id="element-26" data-mp="1i1ibqdw1x7li">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-27" data-mp="ldazgasz85k4">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          repeat: Infinity,
          duration: 20,
          ease: 'linear'
        }} className="absolute -top-20 -left-20 w-64 h-64 bg-white/10 rounded-full blur-2xl" data-id="element-28" data-mp="qaudb9lrigbj" />
          <motion.div animate={{
          rotate: -360
        }} transition={{
          repeat: Infinity,
          duration: 25,
          ease: 'linear'
        }} className="absolute -bottom-32 -right-32 w-96 h-96 bg-white/10 rounded-full blur-3xl" data-id="element-29" data-mp="29w0w8prfrji9" />
        </div>

        <div className="relative z-10" data-id="element-30" data-mp="1qypzbbta125z">
          <div className="flex justify-center gap-4 mb-8" data-id="element-31" data-mp="1qzr8tbun9gll">
            {['https://cdn.magicpatterns.com/uploads/uHoywi9LZdAdwU5JEKQBAW/idle.png', 'https://cdn.magicpatterns.com/uploads/qkNynjUmvKbpAULdLRzmwv/idle.png', 'https://cdn.magicpatterns.com/uploads/v4Se2ApBqkYYxFpaRLA9zQ/idle.png', 'https://cdn.magicpatterns.com/uploads/ri6KVPBR8mwek1aPdWpRCw/idle.png', 'https://cdn.magicpatterns.com/uploads/1oc17YR4NiAka92omv2e6V/idle.png'].map((imgUrl, i) => <motion.div key={i} initial={{
            y: 20,
            opacity: 0
          }} whileInView={{
            y: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="w-12 h-12 md:w-16 md:h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center shadow-sm border border-white/30 overflow-hidden" data-id="element-32" data-mp="37fc063kic92h" data-mpi={i}>
                <img src={imgUrl} alt="Pet avatar" className="w-full h-full object-contain p-1.5 md:p-2" data-id="element-33" data-mp="35nuhzfh1dvsd" />
              </motion.div>)}
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-34" data-mp="2czyik3031prw">
            Ready to start your journey?
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-35" data-mp="2hw6tt5b5syts">
            Join thousands of users who are building better habits and
            taking care of themselves — together with their favorite companions.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-36" data-mp="20fruw89oth6m">
            <motion.a href="https://apps.apple.com/us/app/pawchi-self-care-pet/id6764858701" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 rounded-full font-bold text-coral bg-white hover:bg-cream shadow-lg flex items-center justify-center gap-2" data-id="element-37" data-mp="1vhzt8mj8qgp8">
              Download for iOS
            </motion.a>
            <motion.a href="https://play.google.com/store/apps/details?id=app.pawchi.mobile" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto px-8 py-4 rounded-full font-bold text-white bg-warmBrown/20 hover:bg-warmBrown/30 backdrop-blur-sm border border-white/20 shadow-lg flex items-center justify-center gap-2" data-id="element-38" data-mp="17r48289aijqy">
              Download for Android
            </motion.a>
          </div>
        </div>
      </motion.div>
    </section>;
}